// extracted by mini-css-extract-plugin
export var addIcon = "AddIcon-module__addIcon___u0-33";